import React from "react";

import { string } from "prop-types";

const Twitter = ({ color1 = "#000", color2 = "#222" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className="twitter" viewBox="0 0 26.96 21.905">
    <path
      fill={color1}
      d="M26.96,2.593c-1.014,0.442-2.087,0.736-3.185,0.873c1.157-0.687,2.022-1.774,2.431-3.055
    c-1.082,0.642-2.266,1.095-3.5,1.338c-2.087-2.228-5.584-2.342-7.812-0.256c-1.116,1.045-1.749,2.506-1.749,4.035
    c-0.004,0.423,0.039,0.846,0.128,1.26C8.825,6.571,4.68,4.469,1.877,1.008C0.4,3.532,1.146,6.77,3.577,8.395
    c-0.876-0.023-1.733-0.257-2.5-0.681v0.061c0.003,2.631,1.852,4.898,4.428,5.431c-0.473,0.125-0.96,0.186-1.449,0.182
    c-0.351,0.006-0.702-0.025-1.046-0.094c0.732,2.248,2.802,3.79,5.165,3.85c-1.956,1.529-4.369,2.359-6.852,2.356
    C0.881,19.503,0.439,19.478,0,19.425c2.528,1.627,5.473,2.486,8.479,2.475c8.628,0.06,15.671-6.886,15.731-15.514
    c0-0.07,0-0.139,0-0.209c0-0.244-0.008-0.48-0.02-0.714C25.28,4.683,26.219,3.71,26.96,2.593z"
    />
  </svg>
);

Twitter.propTypes = {
  color1: string,
  color2: string,
};

const Facebook = ({ color1 = "#000", color2 = "#222" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className="facebook" viewBox="0 0 11.783 22">
    <path
      fill={color1}
      d="M11.01,12.375l0.611-3.981h-3.82V5.81C7.703,4.715,8.512,3.748,9.607,3.65
  C9.753,3.637,9.9,3.64,10.046,3.659h1.737v-3.39C10.763,0.104,9.733,0.014,8.7,0C5.554,0,3.5,1.907,3.5,5.359v3.035H0v3.981h3.5V22
  h4.3v-9.625H11.01z"
    />
  </svg>
);

Facebook.propTypes = {
  color1: string,
  color2: string,
};

const Share = ({ color1 = "#eee", color2 = "#222" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width="16" height="16">
    <path
      fill="#121212"
      d="M2.5,16.667c2.083-2.917,5-4.25,9.167-4.25v3.417L17.5,10l-5.833-5.833V7.5
      C5.833,8.334,3.333,12.5,2.5,16.667z"
    />
    <path fill="none" d="M20,20H0V0h20V20z" />
  </svg>
);

Share.propTypes = {
  color1: string,
  color2: string,
};

const FontIncrease = ({ lang }) =>
  lang === "en" ? (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" width="24">
      <circle cx="14" cy="14" r="13.5" fill="#eee" />
      <path
        fill="#121212"
        d="M8.758 8.312L4.524 19.688h2.492l.781-2.344h4.109l.789 2.344h2.491L10.93 8.312H8.758zm-.328 7.133l1.414-4.258 1.43 4.258H8.43zM20.656 13.32v-3.054h-2.149v3.054h-2.828v2.039h2.828v3.188h2.149v-3.188h2.82V13.32z"
      />
    </svg>
  ) : (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width="26" height="23">
      <path
        fill="#121212"
        d="M0.039,5.719l0.188-0.328h12.422l0.758,0.758l-0.234,0.375h-0.953v1.242c0,0.344,0.001,0.7,0.004,1.07
        c0.002,0.37,0.004,0.734,0.004,1.094s0.001,0.703,0.004,1.031c0.002,0.328,0.004,0.622,0.004,0.883c0,0.323,0.001,0.644,0.004,0.961
        c0.002,0.317,0.006,0.618,0.012,0.902c0.005,0.284,0.013,0.542,0.023,0.773c0.01,0.231,0.023,0.423,0.039,0.574l-0.57,0.398
        c-0.042-0.036-0.107-0.094-0.195-0.172c-0.089-0.078-0.18-0.159-0.273-0.242s-0.183-0.161-0.266-0.234
        c-0.083-0.073-0.144-0.125-0.18-0.156v-0.016c-0.183-0.453-0.43-0.84-0.742-1.16s-0.641-0.59-0.984-0.809
        c-0.318,0.37-0.691,0.653-1.121,0.852s-0.884,0.297-1.363,0.297c-0.349,0-0.702-0.056-1.059-0.168
        c-0.357-0.112-0.706-0.285-1.047-0.52c-0.341-0.234-0.669-0.535-0.984-0.902c-0.315-0.367-0.605-0.804-0.871-1.309
        c-0.167-0.312-0.319-0.637-0.457-0.973c-0.138-0.336-0.262-0.66-0.371-0.973S1.622,8.364,1.539,8.094
        c-0.083-0.271-0.154-0.5-0.211-0.688C1.396,7.364,1.493,7.32,1.621,7.273c0.127-0.047,0.225-0.075,0.293-0.086
        c0.073,0.141,0.169,0.315,0.289,0.523c0.12,0.208,0.252,0.43,0.398,0.664c0.182,0.599,0.414,1.122,0.695,1.57s0.59,0.82,0.926,1.117
        s0.688,0.52,1.055,0.668s0.725,0.223,1.074,0.223c0.594,0,1.112-0.2,1.555-0.602c0.192-0.177,0.338-0.378,0.438-0.602
        c0.099-0.224,0.164-0.442,0.195-0.656S8.575,9.683,8.555,9.5C8.534,9.317,8.502,9.177,8.461,9.078
        C8.346,8.942,8.206,8.841,8.039,8.773C7.872,8.706,7.7,8.672,7.523,8.672c-0.052,0-0.089,0.003-0.109,0.008
        c0.005,0.016,0.008,0.055,0.008,0.117c0,0.188-0.037,0.367-0.109,0.539C7.239,9.508,7.138,9.657,7.008,9.785
        c-0.13,0.128-0.288,0.23-0.473,0.309c-0.185,0.078-0.39,0.117-0.613,0.117c-0.198,0-0.387-0.042-0.566-0.125S5.018,9.891,4.883,9.75
        c-0.136-0.141-0.242-0.306-0.32-0.496S4.445,8.862,4.445,8.648V8.641c0-0.245,0.047-0.464,0.141-0.656s0.223-0.356,0.387-0.492
        S5.332,7.253,5.559,7.18s0.475-0.112,0.746-0.117c0.177,0,0.38,0.02,0.609,0.059C7.143,7.16,7.381,7.233,7.629,7.34
        c0.247,0.106,0.495,0.254,0.742,0.441c0.247,0.188,0.478,0.43,0.691,0.727c0.344,0.474,0.561,0.954,0.652,1.441
        c0.091,0.487,0.098,0.944,0.02,1.371c0.114,0.156,0.224,0.323,0.328,0.5c0.104,0.177,0.203,0.354,0.297,0.531s0.18,0.351,0.258,0.52
        s0.146,0.327,0.203,0.473c-0.005,0,0.013-0.005,0.055-0.016c-0.026-0.136-0.047-0.292-0.062-0.469s-0.023-0.383-0.023-0.617v-1.648
        c0-0.578-0.001-1.128-0.004-1.648c-0.003-0.521-0.004-0.995-0.004-1.422v-1H0.766L0.039,5.719z"
      />
      <path
        fill="#121212"
        d="M14.219,10.672c0.052-0.083,0.11-0.173,0.176-0.27c0.064-0.097,0.134-0.188,0.207-0.277h0.891
        c0.192,0,0.4-0.001,0.625-0.004c0.224-0.003,0.453-0.007,0.688-0.012c0-0.344,0.002-0.667,0.008-0.969
        c0.005-0.302,0.008-0.562,0.008-0.781V8c0.083-0.062,0.178-0.128,0.285-0.195c0.106-0.067,0.204-0.13,0.293-0.188
        c0.052-0.031,0.104-0.062,0.156-0.094c0.052-0.031,0.106-0.065,0.164-0.102l0.414,0.266c-0.006,0.114-0.008,0.231-0.008,0.352
        s0,0.245,0,0.375c-0.006,0.224-0.008,0.48-0.008,0.77s-0.003,0.593-0.008,0.91c0.328-0.005,0.639-0.009,0.934-0.012
        c0.294-0.003,0.553-0.007,0.777-0.012c0.13-0.005,0.256-0.008,0.379-0.008c0.122,0,0.24,0,0.355,0l0.297,0.391L20.68,10.75
        c-0.053,0.089-0.109,0.181-0.172,0.277s-0.125,0.188-0.188,0.277c-0.198,0-0.498,0.005-0.898,0.016
        c-0.401,0.011-0.842,0.016-1.32,0.016c0,0.234-0.002,0.461-0.004,0.68c-0.003,0.219-0.006,0.423-0.008,0.613
        c-0.003,0.19-0.006,0.359-0.008,0.508c-0.003,0.148-0.004,0.27-0.004,0.363c-0.089,0.067-0.186,0.133-0.289,0.195
        c-0.104,0.062-0.201,0.12-0.289,0.172c-0.053,0.026-0.104,0.055-0.156,0.086c-0.053,0.031-0.107,0.062-0.164,0.094l-0.414-0.266
        c0-0.114,0-0.233,0-0.355s0.002-0.249,0.008-0.379c0.005-0.224,0.008-0.48,0.008-0.77s0.002-0.598,0.008-0.926
        c-0.328,0.005-0.64,0.009-0.934,0.012c-0.295,0.003-0.559,0.004-0.793,0.004c-0.136,0.005-0.265,0.008-0.387,0.008
        c-0.123,0-0.241,0-0.355,0l-0.273-0.422L14.219,10.672z"
      />
    </svg>
  );

FontIncrease.propTypes = {
  lang: string,
};

const FontDecrease = ({ lang }) =>
  lang === "en" ? (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" width="24">
      <circle cx="14" cy="14" r="13.5" fill="#eee" />
      <path d="M10.25 8.313L6.016 19.687h2.492l.781-2.344h4.109l.789 2.344h2.492L12.422 8.313H10.25zm-.328 7.133l1.414-4.258 1.43 4.258H9.922zM17.586 13.906h4.398v1.82h-4.398z" />
    </svg>
  ) : (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 22" width="26" height="23">
      <path
        fill="#121212"
        d="M0.039,5.719l0.188-0.328h12.422l0.758,0.758l-0.234,0.375h-0.953v1.242c0,0.344,0.001,0.7,0.004,1.07
        c0.002,0.37,0.004,0.734,0.004,1.094s0.001,0.703,0.004,1.031c0.002,0.328,0.004,0.622,0.004,0.883c0,0.323,0.001,0.644,0.004,0.961
        c0.002,0.317,0.006,0.618,0.012,0.902c0.005,0.284,0.013,0.542,0.023,0.773c0.01,0.231,0.023,0.423,0.039,0.574l-0.57,0.398
        c-0.042-0.036-0.107-0.094-0.195-0.172c-0.089-0.078-0.18-0.159-0.273-0.242s-0.183-0.161-0.266-0.234
        c-0.083-0.073-0.144-0.125-0.18-0.156v-0.016c-0.183-0.453-0.43-0.84-0.742-1.16s-0.641-0.59-0.984-0.809
        c-0.318,0.37-0.691,0.653-1.121,0.852s-0.884,0.297-1.363,0.297c-0.349,0-0.702-0.056-1.059-0.168
        c-0.357-0.112-0.706-0.285-1.047-0.52c-0.341-0.234-0.669-0.535-0.984-0.902c-0.315-0.367-0.605-0.804-0.871-1.309
        c-0.167-0.312-0.319-0.637-0.457-0.973c-0.138-0.336-0.262-0.66-0.371-0.973S1.622,8.364,1.539,8.094
        c-0.083-0.271-0.154-0.5-0.211-0.688C1.396,7.364,1.493,7.32,1.621,7.273c0.127-0.047,0.225-0.075,0.293-0.086
        c0.073,0.141,0.169,0.315,0.289,0.523c0.12,0.208,0.252,0.43,0.398,0.664c0.182,0.599,0.414,1.122,0.695,1.57s0.59,0.82,0.926,1.117
        s0.688,0.52,1.055,0.668s0.725,0.223,1.074,0.223c0.594,0,1.112-0.2,1.555-0.602c0.192-0.177,0.338-0.378,0.438-0.602
        c0.099-0.224,0.164-0.442,0.195-0.656S8.575,9.683,8.555,9.5C8.534,9.317,8.502,9.177,8.461,9.078
        C8.346,8.942,8.206,8.841,8.039,8.773C7.872,8.706,7.7,8.672,7.523,8.672c-0.052,0-0.089,0.003-0.109,0.008
        c0.005,0.016,0.008,0.055,0.008,0.117c0,0.188-0.037,0.367-0.109,0.539C7.239,9.508,7.138,9.657,7.008,9.785
        c-0.13,0.128-0.288,0.23-0.473,0.309c-0.185,0.078-0.39,0.117-0.613,0.117c-0.198,0-0.387-0.042-0.566-0.125S5.018,9.891,4.883,9.75
        c-0.136-0.141-0.242-0.306-0.32-0.496S4.445,8.862,4.445,8.648V8.641c0-0.245,0.047-0.464,0.141-0.656s0.223-0.356,0.387-0.492
        S5.332,7.253,5.559,7.18s0.475-0.112,0.746-0.117c0.177,0,0.38,0.02,0.609,0.059C7.143,7.16,7.381,7.233,7.629,7.34
        c0.247,0.106,0.495,0.254,0.742,0.441c0.247,0.188,0.478,0.43,0.691,0.727c0.344,0.474,0.561,0.954,0.652,1.441
        c0.091,0.487,0.098,0.944,0.02,1.371c0.114,0.156,0.224,0.323,0.328,0.5c0.104,0.177,0.203,0.354,0.297,0.531s0.18,0.351,0.258,0.52
        s0.146,0.327,0.203,0.473c-0.005,0,0.013-0.005,0.055-0.016c-0.026-0.136-0.047-0.292-0.062-0.469s-0.023-0.383-0.023-0.617v-1.648
        c0-0.578-0.001-1.128-0.004-1.648c-0.003-0.521-0.004-0.995-0.004-1.422v-1H0.766L0.039,5.719z"
      />
      <path
        fill="#121212"
        d="M14.367,10.992c0.057-0.099,0.121-0.203,0.191-0.312s0.139-0.208,0.207-0.297h0.477
        c0.266,0,0.553-0.001,0.863-0.004c0.31-0.003,0.61-0.009,0.902-0.02c0.453-0.011,0.922-0.019,1.406-0.023l0.367,0.484
        c-0.037,0.058-0.073,0.114-0.109,0.172c-0.037,0.058-0.076,0.114-0.117,0.172c-0.068,0.099-0.14,0.202-0.215,0.309
        c-0.076,0.106-0.147,0.204-0.215,0.293c-0.141,0-0.301,0-0.48,0s-0.369,0.001-0.566,0.004c-0.198,0.003-0.4,0.007-0.605,0.012
        c-0.206,0.005-0.405,0.011-0.598,0.016c-0.453,0.005-0.922,0.013-1.406,0.023l-0.305-0.477c0.036-0.058,0.07-0.116,0.102-0.176
        S14.33,11.05,14.367,10.992z"
      />
    </svg>
  );

FontDecrease.propTypes = {
  lang: string,
};

const CommentIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
    <path
      d="M14 0H2a2 2 0 00-2 2v9a2 2 0 002 2h3v2.625a.374.374 0 00.375.375.36.36 0 00.222-.075L9.5 13H14a2 2 0 002-2V2a2 2 0 00-2-2zm.5 11a.5.5 0 01-.5.5H9l-.4.3-2.1 1.575V11.5H2a.5.5 0 01-.5-.5V2a.5.5 0 01.5-.5h12a.5.5 0 01.5.5z"
      data-name="Path 502"
      fill="#121212"
    />
  </svg>
);

const Bookmark = ({ color1 = "#eee", color2 = "#121212" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 16" width="28px" height="28px">
    <path
      fill="#121212"
      d="M10.5,0h-9C0.672,0,0,0.672,0,1.5V16l6-3.5l6,3.5V1.5C12,0.672,11.328,0,10.5,0z M10.5,13.388
    L6,10.763l-4.5,2.625v-11.7c0.001-0.103,0.085-0.187,0.188-0.187h8.625c0.104,0,0.188,0.084,0.188,0.188l0,0L10.5,13.388z"
    />
  </svg>
);
Bookmark.propTypes = {
  color1: string,
  color2: string,
};
const Email = ({ bgcolor = "#121212", color = "#ffffff" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
    <g data-name="Group 3804" transform="translate(-179 -383)">
      <g data-name="Group 3682" transform="translate(-368 -131)">
        <circle
          cx="14"
          cy="14"
          r="14"
          className="cls-1"
          data-name="Ellipse 3"
          transform="translate(547 514)"
          fill={bgcolor}
        />
        <path
          d="M13.735 67.467A.165.165 0 0 1 14 67.6v5.592a1.313 1.313 0 0 1-1.312 1.308H1.313A1.313 1.313 0 0 1 0 73.188V67.6a.164.164 0 0 1 .265-.129c.612.476 1.425 1.08 4.214 3.106A4.892 4.892 0 0 0 7 71.878a4.894 4.894 0 0 0 2.524-1.3c2.789-2.028 3.598-2.635 4.211-3.111zM7 71c.634.011 1.548-.8 2.007-1.132 3.629-2.633 3.9-2.863 4.741-3.519a.654.654 0 0 0 .252-.517v-.52A1.313 1.313 0 0 0 12.688 64H1.313A1.313 1.313 0 0 0 0 65.313v.52a.658.658 0 0 0 .252.517c.837.654 1.113.886 4.741 3.519C5.452 70.2 6.366 71.011 7 71z"
          className="cls-2"
          data-name="Path 185"
          transform="translate(554 458)"
          fill={color}
        />
      </g>
    </g>
  </svg>
);
Email.propTypes = {
  bgcolor: string,
  color: string,
};

const BookmarkActive = () => (
  <svg width="28" height="28" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <circle fill="#EEE" cx="14" cy="14" r="14" />
      <path
        d="M20 23V8.5c0-.417-.146-.77-.438-1.063A1.447 1.447 0 0018.5 7h-9c-.417 0-.77.146-1.063.437A1.447 1.447 0 008 8.5V23l6-3.5 6 3.5z"
        fill="#132437"
        fillRule="nonzero"
      />
    </g>
  </svg>
);

const Print = () => (
  <svg width="28" height="28" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" className="print-icon">
    <path
      fill="#121212"
      d="M448,192V77.25c0-8.49-3.37-16.62-9.37-22.63L393.37,9.37c-6-6-14.14-9.37-22.63-9.37H96
	C78.33,0,64,14.33,64,32v160c-35.35,0-64,28.65-64,64v112c0,8.84,7.16,16,16,16h48v96c0,17.67,14.33,32,32,32h320
	c17.67,0,32-14.33,32-32v-96h48c8.84,0,16-7.16,16-16V256C512,220.65,483.35,192,448,192z M384,448H128v-96h256V448z M384,224H128
	V64h192v48c0,8.84,7.16,16,16,16h48V224z M432,296c-13.25,0-24-10.75-24-24c0-13.26,10.75-24,24-24s24,10.74,24,24
	C456,285.25,445.25,296,432,296z"
    />
  </svg>
);

const CopyLink = ({ bgcolor = "#121212", color = "#ffffff" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
    <g data-name="Group 3805" transform="translate(-179 -427)">
      <g data-name="Group 3675" transform="translate(-474 -24)">
        <g data-name="Group 3674">
          <circle
            cx="14"
            cy="14"
            r="14"
            className="cls-1"
            data-name="Ellipse 3"
            transform="translate(653 451)"
            fill={bgcolor}
          />
        </g>
        <path
          fill={color}
          d="M8.93 5.069a4.154 4.154 0 0 1 .01 5.868l-.01.01-1.837 1.837a4.156 4.156 0 0 1-5.878-5.878L2.23 5.892a.437.437 0 0 1 .746.29 5.039 5.039 0 0 0 .265 1.442.44.44 0 0 1-.1.454l-.358.358a1.969 1.969 0 1 0 2.766 2.8L7.383 9.4a1.968 1.968 0 0 0 0-2.784 2.048 2.048 0 0 0-.283-.235.438.438 0 0 1-.19-.345 1.089 1.089 0 0 1 .32-.815l.576-.576a.439.439 0 0 1 .563-.045 4.167 4.167 0 0 1 .561.47zm3.854-3.854a4.161 4.161 0 0 0-5.878 0L5.069 3.052l-.01.01A4.157 4.157 0 0 0 5.63 9.4a.439.439 0 0 0 .563-.047l.576-.576a1.089 1.089 0 0 0 .32-.815.438.438 0 0 0-.19-.345 2.048 2.048 0 0 1-.283-.234 1.968 1.968 0 0 1 0-2.784l1.837-1.837a1.969 1.969 0 1 1 2.766 2.8l-.358.358a.44.44 0 0 0-.1.454 5.039 5.039 0 0 1 .265 1.442.437.437 0 0 0 .746.29l1.015-1.015a4.161 4.161 0 0 0 0-5.878z"
          className="cls-2"
          data-name="Path 181"
          transform="translate(660 458)"
        />
      </g>
    </g>
  </svg>
);
CopyLink.propTypes = {
  bgcolor: string,
  color: string,
};

const Instagram = ({ bgcolor = "#121212", color = "#ffffff" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
    <g data-name="Group 3807" transform="translate(-383 -427)">
      <g data-name="Group 3679" transform="translate(-463.747 -168)">
        <circle
          cx="14"
          cy="14"
          r="14"
          className="cls-1"
          data-name="Ellipse 3"
          transform="translate(846.747 595)"
          fill={bgcolor}
        />
      </g>
      <path
        fill={color}
        d="M6.927 35.235a3.589 3.589 0 1 0 3.589 3.589 3.583 3.583 0 0 0-3.589-3.589zm0 5.922a2.333 2.333 0 1 1 2.333-2.334 2.337 2.337 0 0 1-2.333 2.333zm4.573-6.069a.837.837 0 1 1-.837-.837.835.835 0 0 1 .837.837zm2.377.85A4.142 4.142 0 0 0 12.745 33a4.169 4.169 0 0 0-2.933-1.131c-1.156-.066-4.619-.066-5.775 0A4.164 4.164 0 0 0 1.1 33a4.156 4.156 0 0 0-1.126 2.934c-.066 1.156-.066 4.619 0 5.775A4.142 4.142 0 0 0 1.1 44.642a4.175 4.175 0 0 0 2.933 1.131c1.156.066 4.619.066 5.775 0a4.142 4.142 0 0 0 2.933-1.131 4.17 4.17 0 0 0 1.131-2.933c.066-1.156.066-4.616 0-5.772zm-1.493 7.012a2.362 2.362 0 0 1-1.331 1.331 15.426 15.426 0 0 1-4.126.281A15.546 15.546 0 0 1 2.8 44.28a2.362 2.362 0 0 1-1.33-1.331 15.426 15.426 0 0 1-.281-4.126A15.546 15.546 0 0 1 1.47 34.7a2.362 2.362 0 0 1 1.33-1.333 15.426 15.426 0 0 1 4.126-.281 15.546 15.546 0 0 1 4.126.281 2.362 2.362 0 0 1 1.331 1.333 15.426 15.426 0 0 1 .281 4.126 15.417 15.417 0 0 1-.281 4.123z"
        className="cls-2"
        data-name="Path 184"
        transform="translate(390.328 402.175)"
      />
    </g>
  </svg>
);
Instagram.propTypes = {
  bgcolor: string,
  color: string,
};

const Linkedin = ({ bgcolor = "#0077b5", color = "#ffffff" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
    <g data-name="Group 3806" transform="translate(-179 -471)">
      <g data-name="Group 3676" transform="translate(-446 70)">
        <path
          d="M14 0A14 14 0 1 1 0 14 14 14 0 0 1 14 0z"
          className="cls-1"
          data-name="Ellipse 3"
          transform="translate(625 401)"
          fill={bgcolor}
        />
        <path
          fill={color}
          d="M3.134 14.017H.231V4.671h2.9zM1.681 3.4a1.689 1.689 0 1 1 1.681-1.7 1.7 1.7 0 0 1-1.681 1.7zM14 14.017h-2.9v-4.55c0-1.084-.022-2.475-1.509-2.475-1.509 0-1.74 1.178-1.74 2.4v4.628h-2.9V4.671h2.785v1.275h.041a3.05 3.05 0 0 1 2.746-1.509C13.46 4.436 14 6.371 14 8.883v5.134z"
          className="cls-2"
          data-name="Path 180"
          transform="translate(632 406.982)"
        />
      </g>
    </g>
  </svg>
);
Linkedin.propTypes = {
  bgcolor: string,
  color: string,
};
const PublisedTimeToggler = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="7.187" height="10" viewBox="0 0 7.187 10">
    <path
      d="M17.539 62.754h5.978a.6.6 0 0 1 .427 1.03l-2.989 2.989a.6.6 0 0 1-.852 0l-2.992-2.989a.6.6 0 0 1 .428-1.03zm6.405-2.638l-2.989-2.989a.6.6 0 0 0-.852 0l-2.992 2.989a.6.6 0 0 0 .427 1.03h5.978a.6.6 0 0 0 .428-1.03z"
      data-name="Path 269"
      transform="translate(-16.934 -56.95)"
      fill="#999999"
    ></path>
  </svg>
);

export {
  Twitter,
  Facebook,
  Share,
  FontIncrease,
  FontDecrease,
  Bookmark,
  BookmarkActive,
  Email,
  CopyLink,
  Print,
  Instagram,
  Linkedin,
  PublisedTimeToggler,
  CommentIcon,
};
